var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GeometryImportModal',{on:{"load":_vm.onLoad},model:{value:(_vm.modelProxy),callback:function ($$v) {_vm.modelProxy=$$v},expression:"modelProxy"}},[_c('IxRes',[_vm._v("Areas.FieldRecordSystem.SR_FieldRecordSystem.ContinueToPreview")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }